import React from "react";
import { motion } from "framer-motion";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ isDarkTheme, toggleTheme }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -100 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1, type: "spring", stiffness: 100 }}
      className="fixed top-4 left-4 md:top-8 md:left-8 z-50"
    >
      <button
        onClick={toggleTheme}
        className="w-14 h-14 rounded-full flex items-center justify-center bg-[--bg-secondary] shadow-md"
      >
        <motion.div
          key={isDarkTheme ? 'dark' : 'light'}
          initial={{ rotate: -90, opacity: 0 }}
          animate={{ rotate: 0, opacity: 1 }}
          transition={{ duration: 0.3 }}
          className="text-[--text-primary]"
        >
          {isDarkTheme ? <Sun className="w-6 h-6" /> : <Moon className="w-6 h-6" />}
        </motion.div>
      </button>
    </motion.div>
  );
}